export default "__VITE_ASSET__BgSIEO5s__"